import './LandingPage.css';
import LandingPage from './LandingPage';

export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/LandingPage/index.ts